module.exports = __webpack_public_path__ + "img/aeroland-payment-hero-image.179aa379.png";